<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <PuiTableMenu ref="menuInfo" @methodEnum='methodEnum'></PuiTableMenu>
      <PuiTable ref="puiTable"></PuiTable>
    </template>
  </BasicLayout>
</template>

<script>
import PuiTable from '../../../../components/subscriberconfig/vonrSubscriber/pui/PuiTable';
import PuiTableMenu from '../../../../components/subscriberconfig/vonrSubscriber/pui/PuiTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeListNoIP';

export default {
  name: 'PuiMainPage',
  components: {
    NeList,
    PuiTable,
    PuiTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("LteUser.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Pui.crumb"),
      },
      netype: [43],
    };
  },
  methods: {
    methodEnum(opcode, params) {
      switch (opcode) {
        case 'add':
          this.$refs.puiTable.openAddPuiPage();
          break;
        case 'addBatch':
          this.$refs.puiTable.openAddBatchPuiPage();
          break;
        case 'mod':
          this.$refs.puiTable.openModPuiPage();
          break;
        case 'del':
          this.$refs.puiTable.delUsers();
          break;
        case 'qry':
          this.$refs.menuInfo.setSearchString();
          this.$refs.puiTable.refreshData();
          break;
        case 'chg':
          this.$refs.puiTable.setfilter(params);
          break;
        case 'src':
          this.$refs.puiTable.filterData();
          break;
        case 'qryPviByPui':
          this.$refs.puiTable.openQryPviByPuiPage();
          break;
        default:
      }
    },
    neClick(ne) {
      this.$refs.puiTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
